angular
  .module('common.directives')
  .directive('privacyModeSettingsEdit', function () {
    return {
      scope: {
        privacySettings: '=',
        privacyMode: '=',
        showPrivacyModeControl: '=',
        selectedBulkDevices: '=',
        version: '=',
        onSubmit: '&',
        onCancel: '&'
      },
      templateUrl:
        './templates/privacy-mode-settings-edit.view.html?t=' +
        window.webpackHash,
      link: function ($scope, $element) {},
      controller: 'PrivacyModeSettingsEditController'
    }
  })
